function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { validEmail } from '@domain-group/fe-helper';
import Loader from '@domain-group/fe-co-loader';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import UserInput from './user-input';
import Footer from './footer';
import cancelIcon from './forgot-password.style';
import * as commonStyles from '../../style/common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ForgotPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getFieldValue", key => this.state.formFields[key].value);
    _defineProperty(this, "getData", () => ({
      email: this.getFieldValue('email').trim()
    }));
    _defineProperty(this, "submitForm", () => {
      if (this.validate()) {
        this.setState({
          isSubmitting: true
        });
        this.props.onRetrievePasswordClick(this.getData().email).finally(() => this.setState({
          isSubmitting: false,
          isSubmitted: true
        }));
      }
      return false;
    });
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.formFields[key];
      var error;
      if (field.required && !value) {
        error = field.requiredErrorMessage;
      } else if (field.validate) {
        error = field.validate(value);
      }
      return {
        value,
        error: error || ''
      };
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.formFields[key].value.trim())
      }), {});
      this.setState({
        formFields: newState
      });
      return Object.values(newState).every(_ref => {
        var error = _ref.error;
        return !error;
      });
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = {
        value,
        error: ''
      };
      this.setState(prevState => ({
        formFields: _objectSpread(_objectSpread({}, prevState.formFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "signInWithEmail", () => this.props.onSignInClick(this.getFieldValue('email')));
    _defineProperty(this, "renderField", (key, type) => {
      var field = this.formFields[key];
      var fieldState = this.state.formFields[key];
      return ___EmotionJSX(UserInput, _extends({
        iconName: field.icon,
        fieldType: type,
        fieldName: key,
        placeHolder: field.label,
        onValueChange: event => this.handleFieldChange(key, event.target.value)
      }, field.canSubmit ? {
        onSubmit: this.submitForm
      } : {}, {
        fieldError: fieldState.error,
        fieldValue: fieldState.value,
        focus: field.focus || false
      }));
    });
    _defineProperty(this, "renderPasswordEmailedUI", () => ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.confirmationTitle
    }, "Help is on its way"), ___EmotionJSX("div", {
      css: commonStyles.confirmationHeaderContent
    }, "Check your inbox (or spam folder) at", ' ', ___EmotionJSX("span", {
      css: cancelIcon
    }, this.getData().email), ___EmotionJSX("br", null), ___EmotionJSX("br", null)), ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, ___EmotionJSX(Button, {
      css: commonStyles.buttonContainerItem,
      onClick: this.signInWithEmail
    }, "Got it"))));
    this.formFields = {
      email: {
        label: 'Email',
        icon: 'email',
        required: true,
        requiredErrorMessage: 'Please enter an email address',
        validate: value => validEmail(value) ? '' : 'Invalid email address',
        focus: true,
        canSubmit: true
      }
    };
    this.allFields = Object.keys(this.formFields);
    this.state = {
      isSubmitted: false,
      isSubmitting: false,
      formFields: {
        email: {
          value: props.initialUsername,
          error: ''
        }
      }
    };
  }
  componentDidMount() {
    setTimeout(() => {
      document.getElementsByName('email')[0].focus();
    }, 1);
  }
  render() {
    if (this.state.isSubmitted && this.props.error.length === 0) {
      return this.renderPasswordEmailedUI();
    }
    return ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.title
    }, "Forgot your password?"), ___EmotionJSX("div", {
      css: commonStyles.headerContent
    }, "No worries! Simply Enter the email you use for your My Allhomes account, and we will email you a password reset link."), this.props.error.length > 0 && ___EmotionJSX("div", {
      css: commonStyles.formSubmitError
    }, "Failed to submit request. Please try again later."), ___EmotionJSX("form", {
      method: "dialog",
      onSubmit: event => {
        event.preventDefault();
        return false;
      }
    }, this.renderField('email', 'text'), ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, ___EmotionJSX(Button, {
      onClick: this.submitForm,
      disabled: this.state.isSubmitting,
      css: commonStyles.buttonContainerItem
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: commonStyles.submitButtonLoader,
      dark: true,
      transparent: true,
      size: "mini"
    }) : 'Reset Password')), ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, ___EmotionJSX(Button, {
      css: commonStyles.cancelButton,
      onClick: this.props.onCloseModalCallback
    }, "Cancel"))), ___EmotionJSX(Footer, {
      onCloseModal: this.props.onCloseModalCallback
    }));
  }
}
ForgotPasswordPage.propTypes = {
  initialUsername: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.shape({})),
  onSignInClick: PropTypes.func,
  onRetrievePasswordClick: PropTypes.func,
  onCloseModalCallback: PropTypes.func.isRequired
};
ForgotPasswordPage.defaultProps = {
  initialUsername: '',
  error: [],
  onSignInClick: () => {},
  onRetrievePasswordClick: () => {}
};
export default ForgotPasswordPage;